module.exports = __webpack_public_path__ + "media/applicants/device_signup_6-9f965907.webp";